import { render } from "./PermissionRow.vue?vue&type=template&id=248bb45d"
import script from "./PermissionRow.vue?vue&type=script&lang=js"
export * from "./PermissionRow.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__